import {
	DeploymentEnvironmentTypeOptions,
	type EnvironmentTypeViewConfiguration,
	type DeploymentEnvironmentType,
} from '../types';

export const toEnvironmentTypeFilter = (
	configuration: EnvironmentTypeViewConfiguration,
): DeploymentEnvironmentType[] => {
	const areAllEnvironmentTypesSelected = Object.values(configuration).every(
		(isSelected) => isSelected,
	);
	if (areAllEnvironmentTypesSelected) {
		return [];
	}
	const { production, staging, development, testing, unmapped } = configuration;
	return [
		...(production ? [DeploymentEnvironmentTypeOptions.PRODUCTION] : []),
		...(staging ? [DeploymentEnvironmentTypeOptions.STAGING] : []),
		...(development ? [DeploymentEnvironmentTypeOptions.DEVELOPMENT] : []),
		...(testing ? [DeploymentEnvironmentTypeOptions.TESTING] : []),
		...(unmapped ? [DeploymentEnvironmentTypeOptions.UNMAPPED] : []),
	];
};

export const toEnvironmentCategoryTypeFilter = (types: string[]): DeploymentEnvironmentType[] => {
	if (types.length === 0) {
		return [];
	}

	// Types are in the format of `PRODUCTION-prod`, `STAGING-staging`, etc.
	const categories = types.map((item) => {
		const parts = item.split('-');
		return parts[0].toLowerCase();
	});

	return [
		...(categories.includes('production') ? [DeploymentEnvironmentTypeOptions.PRODUCTION] : []),
		...(categories.includes('staging') ? [DeploymentEnvironmentTypeOptions.STAGING] : []),
		...(categories.includes('development') ? [DeploymentEnvironmentTypeOptions.DEVELOPMENT] : []),
		...(categories.includes('testing') ? [DeploymentEnvironmentTypeOptions.TESTING] : []),
		...(categories.includes('unmapped') ? [DeploymentEnvironmentTypeOptions.UNMAPPED] : []),
	];
};
